// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`
    },
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/user/end-user`,
    user: {
      root: `${ROOTS.DASHBOARD}/user/end-user`,
      endUser: `${ROOTS.DASHBOARD}/user/end-user`,
      endUserInsights: `${ROOTS.DASHBOARD}/user/end-user-insights`,
      endUserDocumentSubmission: `${ROOTS.DASHBOARD}/user/submissions`,
      vendor: `${ROOTS.DASHBOARD}/user/vendor`,
      vendorInsights: `${ROOTS.DASHBOARD}/user/vendor-insights`,
      staff: `${ROOTS.DASHBOARD}/user/staff`,
      staffRole: `${ROOTS.DASHBOARD}/user/staff-role`,
      permissions: `${ROOTS.DASHBOARD}/user/permissions`
    },
    vehicle: {
      root: `${ROOTS.DASHBOARD}/vehicle/list`,
      all: `${ROOTS.DASHBOARD}/vehicle/list`,
      listing: `${ROOTS.DASHBOARD}/vehicle/listings-request`,
      type: `${ROOTS.DASHBOARD}/vehicle/type`,
      make: `${ROOTS.DASHBOARD}/vehicle/make`,
      model: `${ROOTS.DASHBOARD}/vehicle/model`,
      utilities: `${ROOTS.DASHBOARD}/vehicle/utilities`,
      AddOns: `${ROOTS.DASHBOARD}/vehicle/Add-ons`,
      addOns: `${ROOTS.DASHBOARD}/vehicle/add-ons`,
      vehicleInsights: `${ROOTS.DASHBOARD}/vehicle/insights`,
    },
    bookings: {
      root: `${ROOTS.DASHBOARD}/bookings/all`,
      bookings: `${ROOTS.DASHBOARD}/bookings/all`,
      zeroBookingVendors: `${ROOTS.DASHBOARD}/bookings/zero-booking-vendors`,
      ancillaryFees: `${ROOTS.DASHBOARD}/bookings/ancillary-fees`,
      makeCommissions: `${ROOTS.DASHBOARD}/bookings/make-commissions`,
      bookingInsights: `${ROOTS.DASHBOARD}/bookings/insights`,
    },
    tours: {
      root: `${ROOTS.DASHBOARD}/tours/all`,
      tours: `${ROOTS.DASHBOARD}/tours/all`,
      tourInsights: `${ROOTS.DASHBOARD}/tours/insights`
    },
    assertion: {
      root: `${ROOTS.DASHBOARD}/assertion/claims`,
      claims: `${ROOTS.DASHBOARD}/assertion/claims`
    },
    cash: {
      root: `${ROOTS.DASHBOARD}/cash/revenue`,
      revenue: `${ROOTS.DASHBOARD}/cash/revenue`,
      vendorPayment: `${ROOTS.DASHBOARD}/cash/vendor-payment`,
      refund: `${ROOTS.DASHBOARD}/cash/refund`
    },
    promotion: {
      root: `${ROOTS.DASHBOARD}/promotion/campaign`,
      campaign: `${ROOTS.DASHBOARD}/promotion/campaign`,
      promo: `${ROOTS.DASHBOARD}/promotion/promo`,
      endUserLoyalty: `${ROOTS.DASHBOARD}/promotion/end-user-loyalty`,
      endUserReferral: `${ROOTS.DASHBOARD}/promotion/end-user-referrals`,
      // vendorReferral: `${ROOTS.DASHBOARD}/promotion/vendor-referrals`,
      masterData: `${ROOTS.DASHBOARD}/promotion/master-data`,
    },
    support: {
      root: `${ROOTS.DASHBOARD}/support/end-user-chat`,
      chat: `${ROOTS.DASHBOARD}/support/chat`,
      customerReporting: `${ROOTS.DASHBOARD}/support/customer-reporting`,
      vendorReporting: `${ROOTS.DASHBOARD}/support/vendor-reporting`,
      vehicleReporting: `${ROOTS.DASHBOARD}/support/vehicle-reporting`,
      alerts: `${ROOTS.DASHBOARD}/support/alerts`
    },
    site: {
      root: `${ROOTS.DASHBOARD}/site/legal`,
      legal: `${ROOTS.DASHBOARD}/site/legal`,
      faq: `${ROOTS.DASHBOARD}/site/faq`
    },
    profile: {
      root: `${ROOTS.DASHBOARD}/profile/account`,
      account: `${ROOTS.DASHBOARD}/profile/account`,
      security: `${ROOTS.DASHBOARD}/profile/security`
    }
  }
};